import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Download, Search } from "lucide-react";
import { GuideModal } from "./GuideModal";

export const Navigation = ({ isScrolled, activeSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [guideModalOpen, setGuideModalOpen] = useState(false);

  const navLinks = [
    { href: "#hero", label: "Home" },
    { href: "#about", label: "About" },
    { href: "#process", label: "Our Process" },
    { href: "#contact", label: "Contact" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false);
  };

  const handleGuideClick = (e) => {
    e.preventDefault();
    setGuideModalOpen(true);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav 
        data-testid="main-navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? "bg-white shadow-lg py-4" 
            : "bg-transparent py-6"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
          <a 
            href="#hero" 
            onClick={(e) => scrollToSection(e, "#hero")}
            className={`font-serif text-xl md:text-2xl font-bold tracking-tight ${
              isScrolled ? "text-[#0F172A]" : "text-white"
            }`}
            data-testid="logo-link"
          >
            Next Chapter Moves <span className="text-[#D4AF37]">NC</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className={`nav-link ${isScrolled ? "nav-link-dark" : ""} ${
                  activeSection === link.href.slice(1) ? "text-[#D4AF37]" : ""
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/listings"
              className={`nav-link flex items-center gap-1 ${isScrolled ? "nav-link-dark" : ""}`}
              data-testid="nav-search-listings"
            >
              <Search size={16} />
              Search Listings
            </Link>
          </div>

          <button
            className={`md:hidden ${isScrolled ? "text-[#0F172A]" : "text-white"}`}
            onClick={() => setMobileMenuOpen(true)}
            data-testid="mobile-menu-button"
            aria-label="Open menu"
          >
            <Menu size={28} />
          </button>
        </div>
      </nav>

      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? "open" : ""}`}
        onClick={() => setMobileMenuOpen(false)}
      />

      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`} data-testid="mobile-menu">
        <button
          className="absolute top-6 right-6 text-white"
          onClick={() => setMobileMenuOpen(false)}
          aria-label="Close menu"
        >
          <X size={28} />
        </button>
        <div className="flex flex-col gap-6">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="text-white text-lg font-medium hover:text-[#D4AF37] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <span className="text-white/50 text-lg font-medium flex items-center gap-2">
            <Link to="/listings" className="text-white text-lg font-medium hover:text-[#D4AF37] transition-colors flex items-center gap-2">
              <Search size={18} />
              Search Listings
            </Link>
          </span>
        </div>
      </div>

      <GuideModal isOpen={guideModalOpen} onClose={() => setGuideModalOpen(false)} />
    </>
  );
};
